import {
  Button,
  FlexBox,
  Modal,
  ModalHeader,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useManageRoutineTimesModalStore } from "./useManageRoutineTimesModalStore"
import TimeInput from "../../../components/timeInput/TimeInput"
import { PREFERENCE_KEY } from "../../../constants"
import { useUpdatePreferenceMutation } from "../../../networking/families/mutations"
import useSelectedFamilyMember from "../hooks/useSelectedFamilyMember"

const ManageRoutineTimesModal = () => {
  const { selectedProfile } = useSelectedFamilyMember()
  const {
    isOpen: isOpenManageRoutineTimesModal,
    onClose: onCloseManageRoutineTimesModal,
    tempAfternoonStartTime,
    tempNightStartTime,
    setTempAfternoonStartTime,
    setTempNightStartTime,
    isSaving,
    setIsSaving,
  } = useManageRoutineTimesModalStore()

  const updatePreferenceMutation = useUpdatePreferenceMutation()
  const { t } = useTranslation()

  if (!selectedProfile) return <></>

  const handleSave = () => {
    setIsSaving(true)
    Promise.all([
      updatePreferenceMutation.mutateAsync({
        childId: selectedProfile.user.id,
        key: PREFERENCE_KEY.afternoonStartTime,
        value: tempAfternoonStartTime,
      }),
      updatePreferenceMutation.mutateAsync({
        childId: selectedProfile.user.id,
        key: PREFERENCE_KEY.nightStartTime,
        value: tempNightStartTime,
      }),
    ]).then(() => {
      onCloseManageRoutineTimesModal()
      setIsSaving(false)
    })
  }

  return (
    <Modal
      isOpen={isOpenManageRoutineTimesModal}
      onClose={onCloseManageRoutineTimesModal}
      animate
      style={{ width: "min(400px, 95vw)" }}
    >
      <ModalHeader
        title={t("MRT_TITLE")}
        onClose={onCloseManageRoutineTimesModal}
        showBorderBottom
      />
      <div className="flex flex-col p-6 pt-4 gap-4">
        <FlexBox
          justify="space-between"
          align="center"
          gap={SPACING.space6}
          wrap={false}
        >
          <FlexBox direction="column">
            <Typography variant="bodyBold">{t("MRT_MORNING_ENDS")}</Typography>
            <TimeInput
              modalTitle={t("MRT_SELECT_MORNING")}
              name="morningEnd"
              time={tempAfternoonStartTime}
              setTime={setTempAfternoonStartTime}
              fullWidth
            />
          </FlexBox>
        </FlexBox>
        <FlexBox
          justify="space-between"
          align="center"
          gap={SPACING.space6}
          wrap={false}
        >
          <FlexBox direction="column">
            <Typography variant="bodyBold">
              {t("MRT_AFTERNOON_ENDS")}
            </Typography>
            <TimeInput
              modalTitle={t("MRT_SELECT_AFTERNOON")}
              name="afternoonEnd"
              time={tempNightStartTime}
              setTime={setTempNightStartTime}
              fullWidth
            />
          </FlexBox>
        </FlexBox>
        <Button
          text={t("QUEST_SAVE")}
          fullWidth
          isLoading={isSaving}
          onClick={handleSave}
        />
      </div>
    </Modal>
  )
}

export default ManageRoutineTimesModal
